<div class="row">
  <div class="small-12 columns">
    <h5 class="margin-v padding-b-xs border-b c-neutral flex"><b>{{label}}</b>
      <label class="option_label info margin-l">
        <input (click)="onClickOnToggleAll()" type="checkbox" [checked]="allToggled">
        <i></i> <span>{{'all' | translate:{type: 'plural_female'} }}</span>
      </label>
    </h5>
  </div>
</div>
<form [formGroup]="selectionForm" class="row margin-h margin-small">
  <div class="small-12 columns">
    <label *ngFor="let item of items; let i = index" class="option_label {{item.color}}" for="radio-{{i}}-sol-{{dataToggle}}">
      <input (click)="onClickOnRefreshToggleAll(item)" name="radio-{{i}}-freq" id="radio-{{i}}-sol-{{dataToggle}}" type="checkbox" [checked]="item.toggle">
      <i></i> <span>{{item.label}}</span>
    </label>
  </div>
  <div class="small-12 columns margin-v">
    <button (click)="onClickOnSubmit()" [attr.data-toggle]="dataToggle" class="button success"
            type="submit">{{'confirm' | translate}}</button>
    <button (click)="onClickOnCancel()" [attr.data-toggle]="dataToggle" class="button transparent" type="button"><span
      class="c-dark-gray">{{'cancel'| translate}}</span></button>
  </div>
  <button (click)="onClickOnCancel()" class="close-button" aria-label="Close filter" type="button" [attr.data-toggle]="dataToggle">
    <span>×</span>
  </button>
</form>
